import { render } from "./BlockNumberManageDialog.vue?vue&type=template&id=58f0df42"
import script from "./BlockNumberManageDialog.vue?vue&type=script&lang=js"
export * from "./BlockNumberManageDialog.vue?vue&type=script&lang=js"

import "./BlockNumberManageDialog.vue?vue&type=style&index=0&id=58f0df42&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__